import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { toFormData } from '../../utils/formUtils';

export default {
  load() {
    const url = formUrl('/api/v1/admin/banner_settings');

    return FetchHelpers.get(url);
  },
  create(params) {
    const url = formUrl('/api/v1/admin/banner_settings');

    return FetchHelpers.post(url, params);
  },
  update(id, params) {
    const url = formUrl(`/api/v1/admin/banner_settings/${id}`);
    const formData = toFormData('banner_settings', params);

    return FetchHelpers.putMultipartFormData(url, formData);
  },
  destroy(id) {
    const url = formUrl(`/api/v1/admin/banner_settings/${id}`);

    return FetchHelpers.delete(url);
  },
};
